<template>
  <b-modal
      v-model="showModal"
      size="lg"
      id="customers-modal"
      :title="modalTitle"
      ok-title="Save"
      cancel-variant="outline-secondary"
      @ok.prevent="onSubmit"
  >

    <div
        v-if="isContentLoading"
        class="text-center pt-3"
    >
      <b-spinner label="Loading..." />
    </div>
    <b-form v-else-if="showModal">
      <b-row>
        <b-col cols="12">

          <p
              v-if="createdAtLabel || ordersCount !== null"
              class="customer-meta mb-1"
          >
            <span v-if="createdAtLabel">Created at: {{ createdAtLabel }}</span>
            <span
                v-if="createdAtLabel && ordersCount !== null"
                class="customer-meta__sep"
            >·</span>
            <span v-if="ordersCount !== null">
              {{ ordersLabel }} total:
              <a
                  :href="customerOrdersHref"
                  class="customer-meta__orders-link"
                  @click="onCustomerOrdersClick"
              >
                {{ ordersCount }}
              </a>
            </span>
          </p>

          <b-form-group
              label="Name"
              label-for="name"
          >
            <b-form-input
                v-model="edited.name"
                placeholder="Name"
                required
            />
            <small class="text-danger" v-if="v$.edited.name.$error">Name is required</small>
          </b-form-group>

          <b-form-group
              label="Picture"
              label-for="customer-picture"
          >
            <b-form-file
                id="customer-picture"
                accept=".jpg,.jpeg,.png,.gif,.webp"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @change="onPictureInput"
            />
            <b-img
                v-if="picturePreview"
                thumbnail
                rounded="circle"
                fluid
                :src="picturePreview"
                class="mt-1"
                :style="{ width: '120px', height: '120px', objectFit: 'cover' }"
                alt=""
            />
          </b-form-group>

          <b-form-group
              label="Email"
              label-for="email"
          >
            <b-form-input
                v-model="edited.email"
                placeholder="Email"
                type="email"
                required
            />
            <small class="text-danger" v-if="v$.edited.email.$error">Email is required</small>
          </b-form-group>

          <b-form-group
              label="Password"
              label-for="password"
              v-show="false"
          >
            <b-form-input
                v-model="edited.password"
                placeholder="Password"
                required
                readonly
            />
            <small class="text-danger" v-if="v$.edited.password.$error">Password is required</small>
          </b-form-group>

          <b-form-group
              label="Phone number (optional)"
              label-for="input-phone"
              class="mb-2"
          >
            <PhoneNumberInput
                id="input-phone"
                v-model:dial="customerDial"
                v-model:number="customerNumber"
                @change="onCustomerPhoneInput"
            />
            <small class="text-danger" v-if="phoneError">{{ phoneError }}</small>
          </b-form-group>

          <b-form-group
              label="Card last 4 digits"
              label-for="card_last_4"
          >
            <b-form-input
                id="card_last_4"
                v-model="edited.card_last_4"
                placeholder="Enter card last 4 digits"
                type="number"
                :min="1"
                :max="9999"
            />
          </b-form-group>

          <b-form-group
              label="Description"
              label-for="description"
          >
            <b-form-textarea
                v-model="edited.description"
                placeholder="Description"
                rows="3"
                max-rows="6"
            />
          </b-form-group>

        </b-col>
      </b-row>


      <b-row>
        <b-col cols="12" class="pt-1">
          <h5 class="pt-1">Customer primary address</h5>
          <b-row>
            <b-col class=" p-1">

              <b-form-group label="Country" label-for="address-country">
                <CountrySelect
                    input-id="address-country"
                    v-model="address.country_id"
                    :clearable="false"
                />
                <small class="text-danger" v-if="vAddress$.address.country_id.$error">Required</small>
              </b-form-group>

              <b-form-group
                  label="Region"
                  label-for="region"
              >
                <RegionSelect
                    input-id="region"
                    v-model="address.region_id"
                    :country-id="address.country_id"
                    :clearable="false"
                />
                <small class="text-danger" v-if="vAddress$.address.region_id.$error">Required</small>
              </b-form-group>

              <b-form-group
                  label="City"
                  label-for="city"
              >
                <b-form-input
                    id="city"
                    v-model="address.city"
                    placeholder=""
                    required
                />
                <small class="text-danger" v-if="vAddress$.address.city.$error">Required</small>
              </b-form-group>

              <b-form-group
                  label="Address line 1"
                  label-for="address_line_1"
              >
                <b-form-input
                    id="address_line_1"
                    v-model="address.address_line_1"
                    placeholder=""
                    required
                />
                <small class="text-danger" v-if="vAddress$.address.address_line_1.$error">Required</small>
              </b-form-group>

              <b-form-group
                  label="Address line 2"
                  label-for="address_line_2"
              >
                <b-form-input
                    id="address_line_2"
                    v-model="address.address_line_2"
                    placeholder=""
                />
              </b-form-group>

              <b-form-group
                  label="Zip code"
                  label-for="zip_code"
              >
                <b-form-input
                    id="zip_code"
                    v-model="address.zip_code"
                    placeholder=""
                    required
                />
                <small class="text-danger" v-if="vAddress$.address.zip_code.$error">Required</small>
              </b-form-group>

              <b-form-group
                  label="Name"
                  label-for="name"
              >
                <b-form-input
                    id="name"
                    v-model="address.name"
                    placeholder=""
                    required
                />
                <small class="text-danger" v-if="vAddress$.address.name.$error">Required</small>
              </b-form-group>

              <b-form-group
                  label="Phone number"
                  label-for="address-phone"
              >
                <PhoneNumberInput
                    id="address-phone"
                    v-model:dial="addressDial"
                    v-model:number="addressNumber"
                    option-key-prefix="address"
                    required
                />
              </b-form-group>

              <b-form-group>
                <b-form-textarea
                    v-model="address.description"
                    placeholder="Description / Instructions"
                    rows="3"
                    max-rows="6"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>

  </b-modal>
</template>
<script setup>
import { watch, ref, computed, reactive, nextTick, inject } from 'vue';
import { useRouter } from 'vue-router';
import {mapActions, mapGetters, useStore} from "vuex";
import vSelect from 'vue-select';
import {
  BButton, BCol, BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormDatepicker, BFormFile,
  BFormGroup,
  BFormInput,
  BFormTextarea, BImg, BModal, BRow,
  BSpinner,
  VBModal
} from "bootstrap-vue";
import useVuelidate from '@vuelidate/core';
import { email, integer, minLength, minValue, numeric, required } from "@vuelidate/validators";
import {sweetError, sweetWarning} from "@/libs/sweet-alerts";
import { toastSuccess, toastFailure } from '@/libs/toastification';
import { hasCustomUserPicture, normalizeImageUrl } from '@/libs/utils';
import { formatCompanyDateTime } from '@/libs/companyTime';
import PhoneNumberInput from '@/views/Components/Elements/PhoneNumberInput.vue';
import CountrySelect from '@/views/Components/Elements/CountrySelect.vue';
import RegionSelect from '@/views/Components/Elements/RegionSelect.vue';
import {
  buildFullPhone,
  ensureDialInOptions,
  isValidFullPhone,
  normalizeDialCode,
  parseFullPhone,
  usePhoneCountries,
} from '@/libs/phoneNumber';
import { ORDER_CUSTOMER_SELECT_KEY } from '@/constants/injectionKeys';

const store = useStore();
const router = useRouter();

const cloneObject = (object) => {
  return JSON.parse(JSON.stringify(object))
}

/** Laravel JSON errors: { message }, validation { errors }, or plain HTML string body */
const getAxiosErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  if (data == null) {
    return fallback;
  }
  if (typeof data === 'string') {
    const trimmed = data.trim();
    return trimmed.length ? trimmed : fallback;
  }
  if (typeof data.message === 'string' && data.message.length) {
    return data.message;
  }
  if (data.errors && typeof data.errors === 'object') {
    const first = Object.values(data.errors).flat()[0];
    if (typeof first === 'string' && first.length) {
      return first;
    }
  }
  return fallback;
};

const companyPurpose = ref(window.companyPurpose);
const companyId = ref(window.companyId);

const { phoneDialOptions, defaultDialCode, loadPhoneCountries } = usePhoneCountries();

const initialDialCode = () => {
  const fromWindow = normalizeDialCode(window.companyPhoneCode);
  if (fromWindow && fromWindow !== '0') {
    return fromWindow;
  }
  return defaultDialCode() || '1';
};

const customerDial = ref(initialDialCode());
const customerNumber = ref('');
const addressDial = ref(initialDialCode());
const addressNumber = ref('');
const phoneError = ref('');

const ensureCustomerDialInOptions = () => {
  ensureDialInOptions(customerDial, phoneDialOptions.value, defaultDialCode);
};

const ensureAddressDialInOptions = () => {
  ensureDialInOptions(addressDial, phoneDialOptions.value, defaultDialCode);
};

const parseStoredPhone = (phone) => (
  parseFullPhone(phone, phoneDialOptions.value, defaultDialCode)
);

const setCustomerPhoneFields = (phone) => {
  const parsed = parseStoredPhone(phone);
  customerDial.value = parsed.dialCode;
  customerNumber.value = parsed.national;
  ensureCustomerDialInOptions();
};

const setAddressPhoneFields = (phone) => {
  const parsed = parseStoredPhone(phone);
  addressDial.value = parsed.dialCode;
  addressNumber.value = parsed.national;
  ensureAddressDialInOptions();
};

const syncAddressPhoneFromCustomer = () => {
  addressDial.value = customerDial.value;
  addressNumber.value = customerNumber.value;
};

const onCustomerPhoneInput = () => {
  phoneError.value = '';
  syncAddressPhoneFromCustomer();
};

const resetCustomerForm = () => {
  Object.assign(edited, cloneObject(defaultCustomer));
  Object.assign(address, cloneObject(defaultAddress));
  pictureFile.value = null;
  picturePreview.value = '';
  const dialCode = defaultDialCode();
  customerDial.value = dialCode;
  customerNumber.value = '';
  addressDial.value = dialCode;
  addressNumber.value = '';
  phoneError.value = '';
  ensureCustomerDialInOptions();
  ensureAddressDialInOptions();
};

const generatePassword = () => {
  const lowercase = 'abcdefghjkmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHJKMNOPQRSTUVWXYZ';
  const numbers = '123456789';
  const symbols = '!@#$%^&*';

  const allChars = lowercase + uppercase + numbers + symbols;
  let password = '';

  // Ensure at least one character from each category
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];

  // Fill the rest randomly
  while (password.length < 8) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  // Shuffle the password
  return password.split('').sort(() => Math.random() - 0.5).join('');
};


const defaultCustomer = {
  id: null,
  name: '',
  email: '',
  password: generatePassword(),
  phone: '',
  description: '',
  card_last_4: '',
  created_at: null,
  orders_count: null,
};

const defaultAddress = {
  id: null,
  country_id: window.companyCountryId,
  region_id: null,
  city: '',
  address_line_1: '',
  address_line_2: '',
  zip_code: '',
  name: '',
  phone: '',
  description: '',
  default: true,
  user_id: null
};

const props = defineProps({
  customer: {
    type: Object,
    default: null,
  },
  clickDate: {
    type: Date,
    default: null,
  },
  afterCustomerCreated: {
    type: Function,
    default: null,
  },
});

const emit = defineEmits(['customer-created']);

const selectOrderCustomer = inject(ORDER_CUSTOMER_SELECT_KEY, null);

const notifyCustomerCreated = (customer) => {
  store.commit('customers/SET_ORDER_CREATED_CUSTOMER', customer);
  emit('customer-created', customer);

  if (typeof selectOrderCustomer === 'function') {
    selectOrderCustomer(customer);
  }

  if (typeof props.afterCustomerCreated === 'function') {
    props.afterCustomerCreated(customer);
  }
};

const showModal = ref(false);
const isContentLoading = ref(true);
const isFormLoading = ref(false);
const pictureFile = ref(null);
const picturePreview = ref('');

const customer = computed(() => store.state.customers.customer);

const address = reactive(cloneObject(defaultAddress));
const edited = reactive(cloneObject(defaultCustomer));

const modalTitle = computed(() => {
  const id = edited?.id;
  return id != null && Number(id) > 0 ? 'Edit customer' : 'Add new customer';
});

const createdAtLabel = computed(() => {
  const value = edited.created_at || props.customer?.created_at || null;
  if (!value) {
    return '';
  }
  return formatCompanyDateTime(value) || '';
});

const ordersCount = computed(() => {
  if (edited.id == null || !(Number(edited.id) > 0)) {
    return null;
  }
  if (edited.orders_count === null || edited.orders_count === undefined) {
    return null;
  }
  return Number(edited.orders_count) || 0;
});

const ordersLabel = computed(() => (
  window.companyPurpose === 'rent' ? 'Bookings' : 'Orders'
));

const customerOrdersRoute = computed(() => ({
  name: (window.companyPurpose === 'rent' ? 'bookings' : 'orders') + '_by_user',
  params: { customerId: edited.id },
}));

const customerOrdersHref = computed(() => {
  if (edited.id == null) {
    return '#';
  }
  const base = window.companyPurpose === 'rent' ? '/admin/bookings/customer' : '/admin/orders/customer';
  return `${base}/${edited.id}`;
});

const onCustomerOrdersClick = async (event) => {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) {
    showModal.value = false;
    return;
  }
  event.preventDefault();
  if (edited.id == null) {
    return;
  }
  showModal.value = false;
  await router.push(customerOrdersRoute.value);
};

const validatePhoneForm = () => {
  phoneError.value = '';

  if (!String(customerNumber.value || '').trim()) {
    return true;
  }

  if (!isValidFullPhone(buildFullPhone(customerDial.value, customerNumber.value))) {
    phoneError.value = 'Please enter a valid phone number';
    return false;
  }

  return true;
};

const rules = {
  edited: {
    name: { required, minLength: minLength(3) },
    password: { required, minLength: minLength(8) },
    email: { required, email },
  }
};

const rulesAddress = {
  address: {
    country_id: { required },
    region_id: { required },
    city: { required },
    address_line_1: { required },
    zip_code: { required, numeric },
    name: { required },
  }
};

const v$ = useVuelidate(rules, { edited });
const vAddress$ = useVuelidate(rulesAddress, { address });

watch(customer, (newCustomer) => {
  if (props.customer === null) {
    return;
  }

  if (!newCustomer) {
    resetCustomerForm();
    return;
  }

  applyCustomerPayload(newCustomer);
});

const applyCustomerPayload = (rawCustomer) => {
  const payload = rawCustomer?.data ?? rawCustomer;
  const id = payload?.id;

  if (id == null || !(Number(id) > 0)) {
    resetCustomerForm();
    return;
  }

  edited.id = payload.id;
  edited.name = payload.name ?? '';
  edited.email = payload.email ?? '';
  edited.phone = payload.phone ?? '';
  edited.created_at = payload.created_at ?? props.customer?.created_at ?? null;
  edited.orders_count = payload.orders_count ?? payload.sales_count ?? 0;
  setCustomerPhoneFields(edited.phone);
  const primaryAddress = payload.addresses?.find((item) => item.default === 1) || payload.addresses?.[0];
  if (primaryAddress) {
    address.id = primaryAddress.id ?? null;
    address.country_id = primaryAddress.country_id ?? window.companyCountryId;
    address.region_id = primaryAddress.region_id ?? null;
    address.city = primaryAddress.city || '';
    address.address_line_1 = primaryAddress.address_line_1 || '';
    address.address_line_2 = primaryAddress.address_line_2 || '';
    address.zip_code = primaryAddress.zip_code || '';
    address.name = primaryAddress.name || payload.name || '';
    address.description = primaryAddress.description || '';
    address.default = primaryAddress.default ?? true;
    address.user_id = primaryAddress.user_id ?? payload.id ?? null;

    if (primaryAddress.phone) {
      setAddressPhoneFields(primaryAddress.phone);
    } else {
      syncAddressPhoneFromCustomer();
    }
  } else {
    Object.assign(address, cloneObject(defaultAddress));
    address.name = payload.name || '';
    syncAddressPhoneFromCustomer();
  }
  edited.card_last_4 = payload.card_last_4 ?? '';
  edited.description = payload.description ?? '';
  edited.company_id = payload.company_id;
  pictureFile.value = null;
  picturePreview.value = hasCustomUserPicture(payload.picture)
    ? normalizeImageUrl(payload.picture)
    : '';
};

const onPictureInput = (event) => {
  const file = event?.target?.files?.[0] || null;
  pictureFile.value = file;
  if (!file) {
    picturePreview.value = '';
    return;
  }
  const reader = new FileReader();
  reader.onload = (loadEvent) => {
    picturePreview.value = loadEvent.target?.result || '';
  };
  reader.readAsDataURL(file);
};

watch(() => edited.name, (userName) => {
  if (userName) {
    address.name = userName;
  }
});


const openCreateModal = async () => {
  isContentLoading.value = true;
  showModal.value = false;
  store.commit('customers/SET_CUSTOMER', null);

  await Promise.all([
    loadPhoneCountries(),
    store.dispatch('companies/loadCountries').catch(() => {}),
  ]);
  resetCustomerForm();
  ensureCustomerDialInOptions();
  ensureAddressDialInOptions();
  v$.value.$reset();
  vAddress$.value.$reset();

  isContentLoading.value = false;
  await nextTick();
  showModal.value = true;
};

const openEditModal = async (customerId) => {
  isContentLoading.value = true;
  showModal.value = false;

  try {
    await Promise.all([
      loadPhoneCountries(),
      store.dispatch('companies/loadCountries').catch(() => {}),
    ]);
    const loaded = await store.dispatch('customers/loadCustomer', customerId);
    applyCustomerPayload(loaded);
    if (!edited.created_at && props.customer?.created_at) {
      edited.created_at = props.customer.created_at;
    }
    isContentLoading.value = false;
    await nextTick();
    showModal.value = true;
  } catch (error) {
    showModal.value = false;
    isContentLoading.value = false;
    toastFailure('Something went wrong: ' + error.message);
  }
};

watch(() => props.clickDate, async () => {
  if (!props.clickDate) {
    return;
  }

  if (props.customer !== null) {
    const customerId = props.customer.id;
    if (customerId) {
      await openEditModal(customerId);
    }
    return;
  }

  await openCreateModal();
}, { immediate: true });


const onSubmit = async (event) => {

  event.preventDefault();

  console.log('Submitting...');

  const isFormCorrect = await v$.value.$validate();
  const isPhoneValid = validatePhoneForm();
  const isAddressFormCorrect = await vAddress$.value.$validate();

  if (!isFormCorrect || !isPhoneValid || !isAddressFormCorrect) {
    return;
  }

  await submitForm();
};

const submitForm = async () => {

  isFormLoading.value = true;
  syncAddressPhoneFromCustomer();

  const customerPhone = String(customerNumber.value || '').trim()
    ? buildFullPhone(customerDial.value, customerNumber.value)
    : null;
  const addressPhone = String(addressNumber.value || '').trim()
    ? buildFullPhone(addressDial.value, addressNumber.value)
    : (customerPhone || null);

  edited.phone = customerPhone;
  address.phone = addressPhone;

  const formData = new FormData();
  const appendIfPresent = (key, value) => {
    if (value !== null && value !== undefined && value !== '') {
      formData.append(key, value);
    }
  };

  if (edited.id != null) {
    formData.append('id', edited.id);
  }
  appendIfPresent('name', edited.name);
  appendIfPresent('email', edited.email);
  appendIfPresent('phone', customerPhone);
  appendIfPresent('description', edited.description);
  appendIfPresent('card_last_4', edited.card_last_4);
  if (edited.id == null) {
    appendIfPresent('password', edited.password);
  }
  if (pictureFile.value instanceof File) {
    formData.append('picture', pictureFile.value);
  }

  if (edited.id != null) {
    store.dispatch('customers/updateCustomer', { formData })
        .then(() => {
          showModal.value = false;
          toastSuccess('Successfully updated');
        })
        .catch((error) => {
          toastFailure(getAxiosErrorMessage(error, 'Failed to update'));
        })
        .finally(() => {
          isFormLoading.value = false;
        });
  } else {
    try {
      const response = await store.dispatch('customers/addCustomer', { formData });
      const customerId = response?.id ?? response?.data?.id;

      if (!customerId) {
        throw new Error('Customer was created but no id was returned');
      }

      const draftAddress = {
        ...address,
        user_id: customerId,
        phone: addressPhone,
        default: true,
      };

      let savedAddress = { ...draftAddress };

      try {
        const addressResponse = await store.dispatch('addresses/addAddress', draftAddress);
        const responseAddress = addressResponse?.data ?? addressResponse ?? {};
        savedAddress = {
          ...draftAddress,
          ...responseAddress,
          country_id: responseAddress.country_id ?? draftAddress.country_id ?? responseAddress.country?.id,
        };
        toastSuccess('Address added');
      } catch (addressError) {
        toastFailure(getAxiosErrorMessage(addressError, 'Customer saved, but address could not be added'));
      }

      const createdCustomer = {
        id: customerId,
        name: edited.name,
        email: edited.email,
        phone: customerPhone,
        picture: response?.picture ?? response?.data?.picture ?? null,
        card_last_4: edited.card_last_4,
        description: edited.description,
        addresses: [savedAddress],
      };

      notifyCustomerCreated(createdCustomer);
      toastSuccess('Customer added');
      showModal.value = false;
    } catch (error) {
      toastFailure(getAxiosErrorMessage(error, 'Failed to add'));
    } finally {
      isFormLoading.value = false;
    }
  }
};

</script>
<style scoped>
.customer-meta {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.3;
  color: #6e6b7b;
}

.customer-meta__sep {
  margin: 0 0.4rem;
}

.customer-meta__orders-link {
  font-weight: 600;
}
</style>
